<template>
  <!-- 评论数组 -->
  <div class="comment-list">
    <div class="up">
      <div class="photo">
        <img
          :src="item.commentAuthorPhoto"
          alt=""
          v-if="item.commentAuthorPhoto"
        />
        <img src="@/assets/images/1.jpg" alt="" v-else />
      </div>
      <div class="up-info">
        <div class="name" v-if="item.commentParent == '0' || !item.replyTo">
          {{ item.commentAuthor || "匿名用户" }}
        </div>
        <div class="name" v-else>
          {{ item.commentAuthor || "匿名用户" }}
          <span>回复</span>
          {{ item.replyTo || "匿名用户" }}
        </div>
        <div class="time">
          <span>{{ item.commentTime }}</span>
          <button @click.stop="showPopup(item, 'up')">回复</button>
        </div>
      </div>
    </div>
    <div class="floor">
      <div class="content">{{ item.commentContent }}</div>
      <template v-if="item.childComment">
        <div class="reply-list" v-for="citem in item.childComment">
          <commentList
            :item="citem"
            @show="showPopup(item, 'floor')"
          ></commentList>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: "commentList",
  props: {
    item: {
      type: Object,
      default: () => null,
    },
  },
  methods: {
    showPopup(item, type) {
      this.$emit("show", item, type);
    },
  },
};
</script>
